import { Component, OnInit, Input } from '@angular/core';

import { I18nService } from './i18n.service';
import { LanguageService } from '@app/@core/services/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  standalone: false,
})
export class LanguageSelectorComponent implements OnInit {
  @Input() icon = false;
  languageMap: { [key: string]: string } = {
    'en-US': 'English',
    ar: 'العربية',
  };
  constructor(
    private i18nService: I18nService,
    private languageService: LanguageService,
  ) {}

  ngOnInit() {}

  setLanguage(language: string) {
    let targetedLanguage = language;
    this.i18nService.language = targetedLanguage;
    this.languageService.language = targetedLanguage;
    this.languageService.changeHtmlDirection(targetedLanguage);
    location.reload();
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }
}
